import { DateAdvancedFilterModel, JoinAdvancedFilterModel, ScalarAdvancedFilterModelType } from 'ag-grid-enterprise';
import { addDays, isDate } from 'date-fns';

import { InputDatePicker } from '@camelot/form-model';
import { ObjectKeys } from '@camelot/utils';

import { GridDateCellComponent, GridDateTimeCellComponent } from '../../../components/templates/date/date.component';
import { DateTimeKind } from '../../../services/dto/metadata';
import { BaseCol, IInputOptions } from '../base-col';
import { DateEditorComponent } from './date-editor.component';
import { DateFilterComponent } from './date-filter.component';

type FilterTyping = JoinAdvancedFilterModel | DateAdvancedFilterModel;

export class DateCol extends BaseCol<FilterTyping> {
  public override getInputForm(options?: IInputOptions) {
    return new InputDatePicker({
      key: this.key,
      label: options?.fromView ? '' : !options?.fromEdit ? this.inputLabel : '',
      rangeEnabled: true,
      value: <any>options?.value,
    });
  }

  public override getFiltersModel(data: any): FilterTyping | null {
    const value = data[this.key];
    if (!value) {
      return null;
    }
    if (isDate(value)) {
      return {
        filterType: 'join',
        type: 'AND',
        conditions: [
          {
            filterType: 'date',
            colId: this.key,
            type: 'greaterThanOrEqual',
            filter: value,
          },
          {
            filterType: 'date',
            colId: this.key,
            type: 'lessThanOrEqual',
            filter: <any>addDays(value, 1),
          },
        ],
      };
    }
    const filters = ObjectKeys(value).reduce<DateAdvancedFilterModel[]>((acc, key) => {
      const data = value[key] ?? null;

      if (data) {
        acc.push({
          filterType: 'date',
          colId: this.key,
          type: this._getTypeOperator(key.toString()),
          filter: data,
        });
      }
      return acc;
    }, []);

    if (filters.length === 0) {
      return null;
    }
    if (filters.length === 1) {
      return filters[0];
    }
    return {
      filterType: 'join',
      type: 'AND',
      conditions: filters,
    };
  }

  public override getColDef() {
    return {
      ...super.getColDef(),
      ...{
        cellEditor: DateEditorComponent,
        cellRenderer:
          this.data.col.dateTimeKind === DateTimeKind.Date ? GridDateCellComponent : GridDateTimeCellComponent,
        filter: DateFilterComponent,
        type: 'date',
      },
    };
  }

  private _getTypeOperator(type: string): ScalarAdvancedFilterModelType {
    if (type === 'to') {
      return 'lessThanOrEqual';
    }
    if (type === 'start') {
      return 'greaterThanOrEqual';
    }
    return 'notBlank';
  }
}
